var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInsightIcon = function SvgInsightIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81557 4.03857C9.16859 3.25008 10.288 3.25008 10.641 4.03857L11.8015 6.63059C12.4038 7.97603 13.4804 9.05264 14.8259 9.65501L17.4179 10.8155C18.2064 11.1685 18.2064 12.2879 17.4179 12.6409L14.8259 13.8014C13.4804 14.4038 12.4038 15.4804 11.8015 16.8258L10.641 19.4178C10.288 20.2063 9.16859 20.2063 8.81557 19.4178L7.65508 16.8258C7.05271 15.4804 5.97611 14.4038 4.63066 13.8014L2.03865 12.6409C1.25015 12.2879 1.25015 11.1685 2.03864 10.8155L4.63066 9.65501C5.97611 9.05264 7.05271 7.97604 7.65508 6.63059L8.81557 4.03857Z",
    fill: "url(#paint0_linear_88_5263)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5605 14L20.5033 16.1057C20.8045 16.7784 21.3428 17.3167 22.0155 17.6179L24.1212 18.5607L22.0155 19.5034C21.3428 19.8046 20.8045 20.3429 20.5033 21.0156L19.5605 23.1213L18.6178 21.0156C18.3166 20.3429 17.7783 19.8046 17.1056 19.5034L14.9999 18.5607L17.1056 17.6179C17.7783 17.3167 18.3166 16.7784 18.6178 16.1057L19.5605 14Z",
    fill: "url(#paint1_linear_88_5263)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5605 1L20.5033 3.1057C20.8045 3.77843 21.3428 4.31673 22.0155 4.61791L24.1212 5.56067L22.0155 6.50342C21.3428 6.80461 20.8045 7.34291 20.5033 8.01564L19.5605 10.1213L18.6178 8.01563C18.3166 7.34291 17.7783 6.80461 17.1056 6.50342L14.9999 5.56067L17.1056 4.61791C17.7783 4.31673 18.3166 3.77842 18.6178 3.1057L19.5605 1Z",
    fill: "url(#paint2_linear_88_5263)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_88_5263",
    x1: 8.2553,
    y1: 2.34747,
    x2: 10.5734,
    y2: 27.1346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DA4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_88_5263",
    x1: 18.87,
    y1: 14.1629,
    x2: 19.9568,
    y2: 25.7833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DA4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_88_5263",
    x1: 18.87,
    y1: 1.1629,
    x2: 19.9568,
    y2: 12.7833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DA4FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInsightIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "insight-icon.e0e52ae27e9dcdc2057bc68fb4a71c80.svg";